import * as React from "react";
import OpQuotesHeadingDsk, { IOpQuotesHeadingDskProps } from "../partials/opQuotesHeadingDsk";
import OpMarketDepthTable, { IOpMarketDepthTableProps } from "../partials/opMarketDepthTable";
import OpQuotesHoldings from "../partials/opQuotesHoldings";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesTab.scss";
import { useRouteMatch } from "react-router-dom";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesEquityTabProps {
	quoteData: any;
	holdingData?: any;
}

const OpQuotesEquityTab: React.FC<IOpQuotesEquityTabProps> = props => {
	const [showHoldings, setShowHoldings] = React.useState(false);
	const [showMarketDepth, setShowMarketDepth] = React.useState(false);
	const futOpt = useRouteMatch().url.split("/")[3];

	const quotesHeadingProps: IOpQuotesHeadingDskProps = {
		dpNm: props.quoteData.qt?.dpNm,
		ltp: props.quoteData.qt?.ltp,
		chLTP: props.quoteData.qt?.chg,
		chLTPPer: props.quoteData.qt?.chgP,
		exc: props.quoteData.qt?.exc,
		ltt: props.quoteData.qt?.ltt,
		expiry:
			futOpt === "future"
				? `${props.quoteData.qt?.dpExpDt} ${props.quoteData.qt?.dpInsTyp || ""}`
				: futOpt === "option"
				? `${props.quoteData.qt?.dpExpDt} ${props.quoteData.qt?.opTyp} ${props.quoteData.qt?.stkPrc}`
				: undefined
	};

	const quotesDetilsProps: IOpMarketDepthTableProps = {
		open: props.quoteData.qt?.o,
		volume: props.quoteData.qt?.vol,
		high: props.quoteData.qt?.h,
		low: props.quoteData.qt?.l,
		tBidQty: props.quoteData.mkd?.buyQty,
		tAskQty: props.quoteData.mkd?.sellQty,
		ask: props.quoteData.mkd?.ask,
		bid: props.quoteData.mkd?.bid,
		spot: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.spot : undefined,
		opInt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.opInt : undefined,
		opIntChgP: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.opIntChgP : undefined,
		hiCt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.hiCt : undefined,
		loCt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.loCt : undefined,
		ltSz: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.ltSz : undefined,
		bidivfut: futOpt === "option" ? props.quoteData.qt?.bidivfut : undefined,
		mns: futOpt === "option" ? props.quoteData.qt?.mns : undefined
	};

	return (
		<section className="quotes_cont">
			<div className="quotes_cont_row va_start">
				<OpQuotesHeadingDsk {...quotesHeadingProps} />

				<button className="change_btn" onClick={console.log}>
					Change
				</button>
			</div>

			<div className="quotes_cont_row m_2">
				<div className="bid_ask">
					<span className="label ib">Bid:</span>
					<span className="value ib">
						{toINR(props.quoteData.mkd?.bid[0].price)} ({props.quoteData.mkd?.bid[0].qty || "--"})
					</span>
					<span className="label ib">Ask:</span>
					<span className="value ib">
						{toINR(props.quoteData.mkd?.ask[0].price)} ({props.quoteData.mkd?.ask[0].qty || "--"})
					</span>
				</div>

				<div className="blue_btns">
					<div className="blue_btn_cont ib">
						{props.holdingData && (
							<button className="blue_btn" onClick={() => setShowHoldings(true)}>
								<i className="edel-icon-purse" /> {toINR(+props.holdingData.hdQtyCnc + +props.holdingData.hdQtyMtf)} qty
							</button>
						)}

						{showHoldings && (
							<>
								<div className="popup_overlay" onClick={() => setShowHoldings(false)} />
								<div className="popup">
									<OpQuotesHoldings
										data={[
											{ label: "Total Quantity", value: toINR(+props.holdingData.hdQtyCnc + +props.holdingData.hdQtyMtf) },
											{
												label: "Total Value",
												value: `₹ ${toINR(
													(+props.holdingData.hdQtyCnc + +props.holdingData.hdQtyMtf) * props.quoteData.mkd?.ask[0].price
												)}`
											}
										]}
										hldgOrPos="holding"
									/>
								</div>
							</>
						)}
					</div>

					<div className="blue_btn_cont ib">
						<button className="blue_btn" onClick={() => setShowMarketDepth(true)}>
							Market Depth
						</button>

						{showMarketDepth && (
							<>
								<div className="popup_overlay" onClick={() => setShowMarketDepth(false)} />
								<div className="popup">
									<OpMarketDepthTable {...quotesDetilsProps} />
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default OpQuotesEquityTab;
